import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { cva } from 'class-variance-authority'
import type { VariantProps } from 'class-variance-authority'

import { cn } from '@/shared/utils/shadcn'

const buttonVariants = cva(
  'fv:inline-flex fv:items-center fv:justify-center fv:gap-2 fv:whitespace-nowrap fv:rounded-full fv:text-sm fv:font-medium fv:transition-all fv:disabled:pointer-events-none fv:disabled:opacity-50 fv:[&_svg]:pointer-events-none fv:[&_svg:not([class*=size-])]:size-4 fv:shrink-0 fv:[&_svg]:shrink-0 fv:outline-none fv:focus-visible:border-ring fv:focus-visible:ring-ring/50 fv:focus-visible:ring-[3px] fv:aria-invalid:ring-destructive/20 fv:dark:aria-invalid:ring-destructive/40 fv:aria-invalid:border-destructive fv:cursor-pointer',
  {
    variants: {
      variant: {
        base: '',
        default: 'fv:bg-accent-fathom fv:text-primary-foreground fv:hover:bg-accent-fathom/90',
        secondary: 'fv:bg-secondary fv:text-muted-foreground fv:hover:bg-secondary/80',
        /* TODO: Variant not finalized */
        outline:
          'fv:border fv:bg-background fv:shadow-xs fv:hover:bg-accent fv:hover:text-accent-foreground fv:dark:bg-input/30 fv:dark:border-input fv:dark:hover:bg-input/50',
        /* TODO: Variant not finalized */
        ghost: 'fv:hover:bg-accent fv:hover:text-accent-foreground fv:dark:hover:bg-accent/50',
        link: /* TODO: Variant not finalized */ 'fv:text-primary fv:underline-offset-4 fv:hover:underline',
        /* TODO: Variant not finalized */
        destructive:
          'fv:bg-destructive fv:text-white fv:hover:bg-destructive/90 fv:focus-visible:ring-destructive/20 fv:dark:focus-visible:ring-destructive/40 fv:dark:bg-destructive/60',
      },
      size: {
        'default': 'fv:h-8 fv:px-4 fv:py-1.5 fv:has-[>svg]:px-3',
        'sm': 'fv:h-[26px] fv:gap-1.5 fv:py-[5px] fv:px-3 fv:has-[>svg]:px-3',
        'lg': 'fv:h-10 fv:px-8 fv:py-2 fv:has-[>svg]:px-4',
        'icon': 'fv:size-8',
        'icon-sm': 'fv:size-[26px]',
        'icon-lg': 'fv:size-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)

function Button({
  className,
  variant,
  size,
  asChild = false,
  ...props
}: React.ComponentProps<'button'> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean
  }) {
  const Comp = asChild ? Slot : 'button'

  return <Comp data-slot='button' className={cn(buttonVariants({ variant, size, className }))} {...props} />
}

export { Button }
